var React = require('react');

function Instagram (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M0 0h16v16H0z","key":0}),React.createElement("g",{"fill":"none","fillRule":"nonzero","key":1},[React.createElement("circle",{"cx":"12.145","cy":"3.892","r":"1","key":0}),React.createElement("g",{"fill":"currentColor","fillRule":"inherit","key":1},[React.createElement("path",{"d":"M8 12c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4zm0-6c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2z","key":0}),React.createElement("path",{"d":"M12 16H4c-2.056 0-4-1.944-4-4V4c0-2.056 1.944-4 4-4h8c2.056 0 4 1.944 4 4v8c0 2.056-1.944 4-4 4zM4 2c-.935 0-2 1.065-2 2v8c0 .953 1.047 2 2 2h8c.935 0 2-1.065 2-2V4c0-.935-1.065-2-2-2H4z","key":1})])])]));
}

Instagram.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Instagram;

Instagram.default = Instagram;
